<script setup>
/**
 * Plan allowance chip, the same in every dock header. By default the shared
 * scene allowance (scenes + breaks) for the Scenes and Breaks docks: `usage`
 * is the compact "5/5" header pill, `notice` the line shown once the limit is
 * reached. `title` overrides the tooltip (Sources: per-scene source limit).
 */
const props = defineProps({
	variant: { type: String, default: 'usage' },
	used: { type: Number, required: true },
	max: { type: Number, required: true },
	reached: { type: Boolean, default: false },
	title: { type: String, default: '' },
	testid: { type: String, default: '' },
})
</script>

<template>
	<span
		v-if="variant === 'usage'"
		class="inline-flex h-5 shrink-0 items-center rounded-full px-1.5 text-[0.65rem] font-semibold tabular-nums"
		:class="reached ? 'bg-warning-transparent text-warning-light' : 'text-surface-7'"
		:title="props.title || `${used} of ${max} scenes used (breaks count as scenes)`"
		:data-testid="testid || undefined"
	>{{ used }}/{{ max }}</span>
	<p
		v-else
		class="m-0 shrink-0 px-3 pb-2 pt-1 text-[0.7rem] leading-snug text-warning-light"
		role="status"
		:data-testid="testid || undefined"
	>
		Scene limit reached · {{ used }} of {{ max }} (breaks count as scenes) ·
		<router-link to="/subscribe" class="font-medium underline hover:text-white">Upgrade</router-link>
	</p>
</template>
